export const ANNOUNCEMENT_CATEGORIES = ['general', 'event', 'holiday', 'exam', 'fee', 'urgent'] as const
export const ANNOUNCEMENT_AUDIENCES = ['all', 'staff', 'students', 'parents', 'class'] as const
export const ANNOUNCEMENT_PRIORITIES = ['normal', 'important', 'urgent'] as const
export const ANNOUNCEMENT_STATUSES = ['draft', 'scheduled', 'published', 'expired'] as const

export type AnnouncementCategory = (typeof ANNOUNCEMENT_CATEGORIES)[number]
export type AnnouncementAudience = (typeof ANNOUNCEMENT_AUDIENCES)[number]
export type AnnouncementPriority = (typeof ANNOUNCEMENT_PRIORITIES)[number]
export type AnnouncementStatus = (typeof ANNOUNCEMENT_STATUSES)[number]

export interface AnnouncementAttachment {
  id: number
  originalName: string
  mimeType: string
  size: number
  downloadUrl: string
}

/** Admin representation (GET /announcements). */
export interface Announcement {
  id: number
  title: string
  body: string
  category: AnnouncementCategory
  audience: AnnouncementAudience
  priority: AnnouncementPriority
  status: AnnouncementStatus
  publishAt: string | null
  expireAt: string | null
  isPinned: boolean
  /** Also shown on the school's public homepage (notices to everyone only). */
  isPublic?: boolean
  classes: { id: number; name: string }[]
  attachment: AnnouncementAttachment | null
  createdBy: { id: number | null; name: string }
  readCount: number
  createdAt: string
  updatedAt: string
}

/** Recipient representation (GET /me/announcements). */
export interface FeedItem {
  id: number
  title: string
  body: string
  category: AnnouncementCategory
  audience: AnnouncementAudience
  priority: AnnouncementPriority
  isPinned: boolean
  publishedAt: string
  expireAt: string | null
  authorName: string
  attachment: AnnouncementAttachment | null
  isRead: boolean
  readAt: string | null
}

export type AnnouncementStats = Record<AnnouncementStatus, number>

export interface AnnouncementFilters {
  status?: string
  category?: string
  audience?: string
}

export interface AnnouncementPayload {
  title: string
  body: string
  category: AnnouncementCategory
  audience: AnnouncementAudience
  priority: AnnouncementPriority
  publishAt: string | null
  expireAt: string | null
  isPinned: boolean
  isPublic: boolean
  classIds: number[]
  attachmentFileId: number | null
}
